import React from 'react';
import { styled } from 'linaria/react';
import { useRouter } from 'next/router';
import { noop } from 'lodash';
import { DownloadReceiptButton } from '@features/payment/download-receipt';
import { FetchQRStatus, PayStatusSBP } from '@entities/payment';
import { homeClickGtm } from '@shared/lib/gtm';
import { Button } from '@shared/ui/molecules';
import { Partners, usePartner } from '@shared/lib/partner';
import { OperationDetailsRs } from '@root/api/ump-ewallet';
import { useIsClient } from '@shared/lib/react';
interface ServicesButtonProps {
  payStatus: string;
  receiptData?: Record<string, unknown>[];
  qrStatusData?: FetchQRStatus;
  formattedDate?: string;
  operationDetails?: OperationDetailsRs;
}
export const ServicesButton = ({
  payStatus,
  receiptData,
  qrStatusData,
  formattedDate,
  operationDetails
}: ServicesButtonProps) => {
  const router = useRouter();
  const isClient = useIsClient();
  const {
    partner
  } = usePartner();
  const generatePathUrl = (nameService: string) => {
    homeClickGtm(nameService);
    router.push(router.query.url ? `/${router.query.url}` : '/').then(noop);
  };
  const handleRedirectButtonClick = () => {
    if (partner === Partners.SMARTSHELL) {
      router.push('/steam');
    } else {
      generatePathUrl(qrStatusData?.paymentPurpose as string);
    }
  };
  return <NoticeButtonsWrapperSBP>
      {isClient && <Button variant="primary" onClick={handleRedirectButtonClick}>
          {router.query.url ? 'Продолжить' : 'На главную'}
        </Button>}
      {/* <NoticeButton title="На главную" icon={<HomeIcon />} onClick={handleToMainPageClick} /> */}
      {payStatus !== PayStatusSBP.REJECTED && <DownloadReceiptButton payStatus={payStatus} receiptData={receiptData} qrStatusData={qrStatusData} formattedDate={formattedDate} operationDetails={operationDetails} />}
    </NoticeButtonsWrapperSBP>;
};
const NoticeButtonsWrapperSBP = /*#__PURE__*/styled('div')({
  name: "NoticeButtonsWrapperSBP",
  class: "n1wjvxnw",
  propsAsIs: false
});

require("./ServicesButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ServicesButton.tsx");